const variant = "default";

// TODO: maybe calculate light/dark automatically from main?
const brandColors = {
  primary: {
    default: "#002a3a",
    light: "#7986cb",
    dark: "#303f9f",
  },
  base: {
    default: "#272525",
    light: "#757678",
    dark: "#ffffff",
  },
  based: {
    default: "#000000",
    light: "#000000",
    dark: "#ffffff",
  },
  secondary: {
    default: "#ffffff",
    light: "#f50057",
    dark: "#c51162",
  },
};

const colors = {
  background: {
    primary: {
      default: "#ffffff",
      light: "#ffffff",
      dark: "#111111",
    },
    basedRev: {
      default: "#000000",
      light: "#000000",
      dark: "#ffffff",
    },
    secondary: {
      default: "#888888",
      light: "rgba(42,41,41,0.6)",
      dark: "#666666",
    },
    tertiary: {
      default: "#cccccc",
      light: "rgba(248, 248, 248, 0.9)",
      dark: "#cccccc",
    },
    error: {
      default: "#f44336",
      light: "#e57373",
      dark: "d32f2f",
    },
    warning: {
      default: "#ff9800",
      light: "#ffb74d",
      dark: "#f57c00",
    },
    info: {
      default: "#2196f3",
      light: "#64b5f6",
      dark: "#1976d2",
    },
    success: {
      default: "#4caf50",
      light: "#81c784",
      dark: "#388f3c",
    },
    brand: {
      ...brandColors.secondary,
    },
  },

  text: {
    primary: {
      default: "#002a3a",
      light: "#002a3a",
      dark: "#002a3a",
    },
    base: {
      default: "#272525",
      light: "#272525",
      dark: "#ffffff",
    },
    based: {
      default: "#000000",
      light: "#000000",
      dark: "#ffffff",
    },
    basedRev: {
      default: "#ffffff",
      light: "#ffffff",
      dark: "#000000",
    },
    grey: {
      default: "#757678",
      light: "#757678",
      dark: "#757678",
    },
    secondary: {
      default: "#ececec",
      light: "#ececec",
      dark: "rgba(0,0,0,0.54)",
    },
    disabled: {
      default: "rgba(0,0,0,0.38)",
      light: "rgba(0,0,0,0.38)",
      dark: "rgba(255,255,255,0.5)",
    },
    error: {
      default: "#f44336",
      light: "#e57373",
      dark: "d32f2f",
    },
    warning: {
      default: "#ff9800",
      light: "#ffb74d",
      dark: "#f57c00",
    },
    info: {
      default: "#2196f3",
      light: "#64b5f6",
      dark: "#1976d2",
    },
    success: {
      default: "#4caf50",
      light: "#81c784",
      dark: "#388f3c",
    },
    brand: {
      ...brandColors.primary,
    },
  },
};

const breakpoint = {
  xs: 430,
  sm: 640,
  ns: 800,
  md: 1024,
  lg: 1200,
  nl: 1420,
  xl: 1600,
  xxl: 1920,
}

const mobileNavBp = 1114;

const breakpoints = [430, 640, 800, 1024, 1200, 1600, 1920]; // default to match `/scss/assists/variables.scss` but can be overwritten (`/util/breakpoints.js`)
const spacing = {}; // ???

const base = {
  fontFamily: "\"Museo Sans\", sans-serif",
  backgroundColor: colors.background.primary[variant],
};

const header = {
  fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
};

const typography = {
  button: {
    sizes: ["1.2rem", "1.2rem", "1.2rem", "1.4rem", "1.4rem", "1.6rem"],
    letterSpacing: "0.1em",
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: "500",
  },

  copy: {
    margin: "0 0 2em",
    fontSize: ["0.8889em", "0.88889em", "0.8889em", "0.8889em", "1em"],
    lineHeight: "1.5em",
    letterSpacing: "0.07em",
    fontWeight: 300,
  },

  kicker: {
    margin: "0 0 .6em", // 8px
    fontSize: "1em", // 14px
    fontColor: brandColors.base.light,
    lineHeight: "1em",
    letterSpacing: "0.15em",
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: "700",
    textTransform: "uppercase"
  },

  h1: {
    margin: ["0 0 0.32em", "0 0 0.32em", "0 0 0.32em", "0 0 0.30em", "0 0 0.28em", "0 0 0.25em",], // 16px
    sizes: ["3.5714em", "3.5714em", "3.5714em", "3.7857em", "4.0714em", "4.5714em"], // 50px, 50px, 50px, 53px, 57px, 64px 
    letterSpacing: "0.01em",
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: 400,
  },
  h2: {
    margin: ["0 0 0.32em", "0 0 0.32em", "0 0 0.32em", "0 0 0.30em", "0 0 0.28em", "0 0 0.25em",], // 16px
    sizes: ["2.5714em", "2.5714em", "2.5714em", "3em", "3.2143em", "3.4286em"], // 36px, 36px, 36px, 42px, 45px, 48px    
    letterSpacing: "0.01em",
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: 400,
  },
  h3: {
    margin:["0 0 1.2174em", "0 0 1.2174em", "0 0 1.2174em", "0 0 0.9333em", "0 0 0.9333em", "0 0 0.8750em",], // 28px
    sizes: ["1.6429em", "1.6429em", "1.6429em", "2.1428em", "2.1428em", "2.2857em"], // 23px, 23px, 23px, 30px, 30px, 32px   
    letterSpacing: "0.01em",
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: 400,
  },
  h4: {
    margin:["0 0 1.1667em", "0 0 1.1667em", "0 0 1.1667em", "0 0 1.1667em", "0 0 1.1667em", "0 0 1.1667em",], // 28px
    sizes: ["1.7143em", "1.7143em", "1.7143em", "1.7143em", "1.7143em", "1.7143em"], // 24px, 24px, 24px, 24px, 24px, 24px
    letterSpacing: "0.01em",
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: 400,
    lineHeight: "1.5",
  },
  h5: {
    margin:["0 0 1.2em", "0 0 1.2em", "0 0 1.2em", "0 0 1.2em", "0 0 1.2em", "0 0 1.2em",], // 24px
    sizes: ["1.4286em", "1.4286em", "1.4286em", "1.4286em", "1.4286em", "1.4286em"], // 20px, 20px, 20px, 20px, 20px, 20px
    letterSpacing: "0.01em",
    fontFamily: "\"Gotham Rounded\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif",
    fontWeight: 400,
    lineHeight: "1.5",
  },
  small:{
    fontSize: ["0.7778em"],
    lineHeight: "1.57"
  }
};

//  TODO
typography.h6 = typography.h5;



export default {
  variant,
  colors,
  brandColors,
  typography,
  breakpoint,
  breakpoints,
  mobileNavBp,
  spacing,
  base,
  header
};
